import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function ReceiptBasicInfoComponent({
  handleInnerFormChange, selectedReceipts, voucherTransactionTypeList, paymentTransactionTypeList,
  ledgerTransactionTypeList, organizationUnitsList, ledgersList
}: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Voucher Transaction Type"
              labelField="Text"
              list={voucherTransactionTypeList}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'VoucherTransactionTypeId'
                )
              }}
              optionName='Choose Transaction Type'
              type="select"
              value={selectedReceipts?.VoucherTransactionTypeId}
              valueField="Value"
            />
            <InputContainer
              label="Payment Transaction Type"
              labelField="Text"
              list={paymentTransactionTypeList}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'PaymentTransactionTypeId'
                );
              }}
              optionName='Choose Payment Transaction Type'
              type="select"
              value={selectedReceipts?.PaymentTransactionTypeId}
              valueField="Value"
            />
            <InputContainer
              label="Organization Unit"
              labelField="OrganizationUnitInfo.Name"
              list={organizationUnitsList}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'OrganizationUnitId'
                )
              }}
              optionName='Choose Organization Unit'
              type="select"
              value={selectedReceipts?.OrganizationUnitId}
              valueField="OrganizationUnitInfo.Id"
            />
            <InputContainer
              label="Ledger Transaction Method"
              labelField="Text"
              list={ledgerTransactionTypeList}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'LedgerTransactionMethod'
                );
              }}
              optionName='Choose Ledger Transaction Method'
              type="select"
              value={selectedReceipts?.LedgerTransactionMethod}
              valueField="Value"
            />
            <InputContainer
              label="Ledger Name"
              labelField="LedgerName"
              list={ledgersList}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'LedgerId'
                )
              }}
              optionName='Choose Ledger Name'
              type="select"
              value={selectedReceipts?.LedgerId}
              valueField="LedgerId"
            />
            <InputContainer
              label="Paid Date"
              name="PaidDateOnUtc"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'PaidDateOnUtc'
                )
              }}
              type="date"
              value={selectedReceipts?.PaidDateOnUtc}
            />
            <InputContainer
              label="From Whom"
              labelField="FromWhom"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'FromWhom'
                );
              }}
              type="text"
              value={selectedReceipts?.FromWhom}
            />
            <InputContainer
              label="Remarks"
              labelField="Remarks"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Remarks'
                );
              }}
              type="text"
              value={selectedReceipts?.Remarks}
            />
          </div>
        }
        expandedPanel="basicInfo"
        headerTitle="Basic Information"
      />
    </>
  )
}